// frontend/src/index.js
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/tailwind.css';

// Components
import App from './App';
import Login from './pages/Login';
import Signup from './pages/Signup';
import LearningPath from './pages/LearningPath';
import DSALearning from './pages/DSALearning';
import ErrorBoundary from './components/ErrorBoundary';

const Root = () => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('accessai-user');
    if (savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        // Check token expiration
        const tokenPayload = JSON.parse(atob(userData.token.split('.')[1]));
        const expirationTime = tokenPayload.exp * 1000;
        if (Date.now() >= expirationTime) {
          localStorage.removeItem('accessai-user');
          return null;
        }
        return userData;
      } catch (error) {
        localStorage.removeItem('accessai-user');
        return null;
      }
    }
    return null;
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem('accessai-user', JSON.stringify(user));
    } else {
      localStorage.removeItem('accessai-user');
    }
  }, [user]);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App user={user} setUser={setUser} />} />
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/signup" element={<Signup setUser={setUser} />} />
          <Route path="/learn/:language" element={<LearningPath user={user} />} />
          <Route path="/dsa" element={<DSALearning user={user} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);